import gsap from "gsap";
import { Flip } from "gsap/Flip";
import AriaAct from "@resources/aria-act/AriaAct";
import HandleVideoEmbeds from "@app/scripts/HandleVideoEmbeds";
import SizeObserverCssVariables from "@resources/size-observer-css-variables/SizeObserverCssVariables";

export default class TenByTenModal {
	constructor() {
		this.triggers = document.querySelectorAll('.tenbyten-card');

		if(!this.triggers) return;

		this.modals = document.querySelectorAll('.tenbyten-modal__item');
		gsap.registerPlugin(Flip)

		this._setEmbedIds();
		this._openModal();
	}

	_openModal() {
		AriaAct.registerListener('click','[aria-controls*="tenbyten-video"]','expandOpen');
		AriaAct.registerListener('click','[aria-controls*="tenbyten-grid-view"]','expandToggle');
		AriaAct.registerListener('click','.tenbyten-modal__close','expandClose');

		window.addEventListener("AriaAct:expandOpen", (e) => {
			this._onOpenVideoModal(e);
			this._onOpenGridViewModal(e);
		});
	}

	_onOpenGridViewModal(e) {
		if( !e.detail.trigger.closest('[aria-controls*="tenbyten-grid-view"]') ) return;

		const header = '.tenbyten-grid-view__header';

		const gridTl = gsap.timeline();

		gridTl
			.fromTo(header, {
				clipPath: 'inset(-72px 100% 0 0)'
			}, {
				clipPath: 'inset(-72px 0% 0 0)',
				duration: 1,
				delay: .2
			})
			.from('.tenbyten-grid-view__grid .tenbyten-card', {
				y: 50,
				autoAlpha: 0,
				stagger: .1
			}, '-=.2')
	}

	_onOpenVideoModal(e) {
		if( !e.detail.trigger.closest('[aria-controls*="tenbyten-video"]') ) return;

		const trigger = e.detail.trigger.closest('[aria-controls*="tenbyten-video"]');

		AriaAct.closeOthersOnOpen(e.detail);

		const videoSizeObserver = new SizeObserverCssVariables("single-video", '.tenbyten-modal [aria-hidden="false"] .atonal-video-embed__holder', true);
		videoSizeObserver.setVideoHeightObserver();

		this.container = e.detail.targets[0];
		const video = this.container.querySelector('[data-embed-cover="cover"]');
		const iframe = this.container.querySelector('iframe');
		const next = this.container.querySelector('.tenbyten-next');

		if(next) {
			next.classList.remove('active');
		} else {
			this._createNext();
		}


		if(trigger.closest('.tenbyten-videos') || trigger.closest('.tenbyten-grid-view__grid')) {
			this.transitionAnimation(trigger, this.container);

			return;
		}

		this._closeAll();

		if(trigger.classList.contains('tenbyten-modal__close')) return;

		gsap.set(this.container, {
			autoAlpha: 1
		});

		video.click();
		this._onEnd(iframe)
	}

	_showAllCovers() {
		this.modals.forEach(modal => {
			modal.querySelector('[data-embed-cover="cover"]').classList.remove('hide');
		})
	}

	_closeAll() {
		this.modals.forEach(modal => {
			const iframe = modal.querySelector('iframe');

			if(iframe?.embedPlayer) {
				iframe.embedPlayer.destroy();
			}

			gsap.set(modal, {
				autoAlpha: 0,
				clearProps: 'all'
			});
		});
	}

	_onEnd(iframe) {
		const next = this.container.querySelector('.tenbyten-next');

		if(!next || typeof(iframe?.embedPlayer) === undefined) return;

		iframe.embedPlayer.callbacks.onEnd = () => {
			next.classList.add('active');
		}

		return

	}


	_createNext() {
		const nextContainer = this.container.nextElementSibling;
		if(!nextContainer) return;

		const nextVideoThumb = document.querySelector(`.tenbyten-card[aria-controls="${nextContainer.id}"]`)
		const nextVideoThumbClone = nextVideoThumb.cloneNode(true);
		const nextWrapper = document.createElement('div');
		const nextLabel = document.createElement('span');
		const currentHolder = this.container.querySelector('.atonal-video-embed__holder');
		const videoHolder = nextVideoThumbClone.querySelector('.tenbyten-card__holder');

		nextLabel.innerHTML = atnlbs_default?.terms_translation?.next_episode || "Next episode";
		nextVideoThumbClone.classList = "";
		nextVideoThumbClone.style = "";
		nextWrapper.classList.add('tenbyten-next');
		nextVideoThumbClone.classList.add('tenbyten-next__video');

		nextWrapper.appendChild(nextVideoThumbClone);

		videoHolder.insertAdjacentElement('afterbegin', nextLabel);
		currentHolder.insertAdjacentElement('beforeend', nextWrapper);
	}

	_setEmbedIds() {
		this.modals.forEach(modal => {
			const embed = modal.querySelector('iframe');

			embed.id = `embed-${modal.id}`;
		});
	}

	transitionAnimation(thumb, modal, open = true) {
		const openTransition = () => {
			const modalEmbed = modal.querySelector('.atonal-video-embed'),
				modalCover = modalEmbed.querySelector('.atonal-video-embed picture'),
				modalElements = modal.querySelectorAll(':scope > *:not(.atonal-video-embed)'),
				video = modal.querySelector('[data-embed-cover="cover"]'),
				thumbImg = thumb.querySelector('img');

			if(!thumbImg) return

			const iframe = modal.querySelector('.atonal-video-embed iframe'),
				thumbImgClone = thumbImg.cloneNode(true),
				originalImgContainer = thumb.querySelector('picture');

			gsap.set(iframe, {autoAlpha: 0});
			gsap.set(modalElements, {autoAlpha: 0, y: 100});
			gsap.set(modalEmbed, {pointerEvents: 'none'});

			const mm = gsap.matchMedia();

			const moonTl = gsap.timeline();

			moonTl
				.to(modal, {
					autoAlpha: 1
				})
				.set('.moon-modal', {x:0})

			mm.add(window.mediaQueries.breakUp.lx, (ctx) => {
				moonTl.add(
					gsap.fromTo('.moon-modal', {
						yPercent: 100,
					}, {
						yPercent: 87,
						delay: .2
					})
				)
			});

			const state = Flip.getState(thumbImg);

			modalCover.innerHTML = "";
			modalCover.appendChild(thumbImg);

			Flip.from(state, {
				duration: 0.5,
				ease: "power2.inOut",
				scale: true,
				onComplete: () => {
					gsap.to(iframe, {autoAlpha: 1})
					gsap.to(modalElements, {
						autoAlpha: 1,
						y: 0,
						clearProps: 'all',
						stagger: .1,
						delay: .1,
					});

					video.click();
					this._onEnd(iframe);

					gsap.set(modalEmbed, {pointerEvents: 'all'});

					originalImgContainer.appendChild(thumbImgClone);
				}
			})

		}

		openTransition();
	}
}
